import Stomp from 'stompjs';
import CallEvent from '../events/CallEvent';
import store from '../../store';

window.weonWebSocket = null;

let informations = {
  login:
    process.env.NODE_ENV == 'development'
      ? process.env.MESSAGE_BROKER_USER
      : window.CONFIG.activemq.username,
  passcode:
    process.env.NODE_ENV == 'development'
      ? process.env.MESSAGE_BROKER_PASSWORD
      : window.CONFIG.activemq.password,
};

let subscribedQueues = [];
var checkInboxQueue = null;
var timerTarget = 10;
var timerActual = 0;

export default class Client {
  constructor(queue, executeFunction) {
    if (!window.weonWebSocket) {
      window.weonWebSocket = this;
    }

    if (!window.weonWebSocket[queue] && queue != 'AGENT-') {
      window.weonWebSocket.connectOnWebSocket(informations, queue);
    }

    if (executeFunction) return window.weonWebSocket;

    return window.weonWebSocket[queue];
  }

  connectOnWebSocket(informations, queue) {
    const URL_BROKER =
      process.env.NODE_ENV == 'development'
        ? process.env.MESSAGE_BROKER_IP
        : window.CONFIG.activemq.url;
    window.weonWebSocket[queue] = {};
    window.weonWebSocket[queue].client = new Stomp.client(URL_BROKER);

    window.weonWebSocket[queue].client.debug = null;

    window.weonWebSocket[queue].client.heartbeat.incoming = 2500;
    window.weonWebSocket[queue].client.heartbeat.outgoing = 2500;
    window.weonWebSocket[queue].client.reconnect_delay = 10000;
    window.weonWebSocket[queue].client.reconnect_delay = 5000;
    window.weonWebSocket[queue].client.connect(informations, () => {
      window.weonWebSocket.subscribeQueue(
        queue,
        window.weonWebSocket.listenerEvents,
      );
    });
  }

  subscribeQueue(queue, functionQueue) {
    window.weonWebSocket[queue].subs = window.weonWebSocket[
      queue
    ].client.subscribe(queue, functionQueue, { ack: 'client' });
    store.dispatch('dialogs/closeDialogReconnectingInformation');
    subscribedQueues.push(queue);
    subscribedQueues = [...new Set(subscribedQueues)];
  }

  listenerEvents(message) {
    if (message.body) {
      message.ack();
      let queueMessage = message.headers.destination.split('/')[2];
      if (queueMessage && queueMessage.includes('INBOX')) {
        timerActual = 0;
      }
      let body = JSON.parse(message.body);
      new CallEvent(body.event, body);
    }
  }

  unsubscribeFromQueueAndDisconnect() {
    if (window.weonWebSocket && subscribedQueues.length > 0) {
      subscribedQueues.forEach((queueToUnsubscribe) => {
        window.weonWebSocket[queueToUnsubscribe].subs.unsubscribe();
        window.weonWebSocket[queueToUnsubscribe].client.disconnect();
      });
      window.weonWebSocket = null;
      subscribedQueues = [];
    }
  }
}

export const isWebSocketConnected = () => {
  const queueAgent = store.state.system.queueListenerMessageBroker;
  if (
    window.weonWebSocket != null &&
    (window.weonWebSocket[queueAgent].client.ws.readyState == 2 ||
      window.weonWebSocket[queueAgent].client.ws.readyState == 3)
  ) {
    console.log(
      '[WEON][SYSTEM][WEBSOCKET][DISCONNECTED] - OFFLINE CONNECTION ON WEBSOCKETS',
    );
    return false;
  }

  return true;
};

export const reconnectWebSocketStomp = () => {
  console.log('[RECONNECT-STOMP] - RECONNECTING AGENT-WEB', subscribedQueues);
  subscribedQueues.forEach((queueToSubscribe) => {
    if (!window.weonWebSocket[queueToSubscribe].client.connected) {
      console.log('[CONNECTION/ONLINE] - Conexão reestabelecida!');
      window.weonWebSocket.connectOnWebSocket(informations, queueToSubscribe);
    }
  });
};

export const unsubscribeWebSocketStompAndDisconnect = () => {
  subscribedQueues.forEach((queueToUnsubscribe) => {
    if (window.weonWebSocket && window.weonWebSocket[queueToUnsubscribe]) {
      if (window.weonWebSocket[queueToUnsubscribe].client.ws.readyState === 1) {
        if (window.weonWebSocket[queueToUnsubscribe].subs) {
          window.weonWebSocket[queueToUnsubscribe].subs.unsubscribe();
        }
        window.weonWebSocket[queueToUnsubscribe].client.disconnect();
      }
    }
  });
  console.log('[CONNECTION/OFFLINE] - Conexão atual fechada!');
};
